import { defineStore } from 'pinia';

export const useSearchStore = defineStore('search', () => {
    const q = ref('');
    const filter = reactive([]);
    return { q, filter };
});
